import { render, staticRenderFns } from "./XCalendar.vue?vue&type=template&id=4b538593&scoped=true&"
import script from "./XCalendar.vue?vue&type=script&lang=js&"
export * from "./XCalendar.vue?vue&type=script&lang=js&"
import style0 from "./XCalendar.vue?vue&type=style&index=0&id=4b538593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b538593",
  null
  
)

export default component.exports